/* eslint-disable */

// TODO - remove this polyfill once we have upgraded core-js to latest version or upgraded to Node 12+
function fromEntries(iterable) {
  return [...iterable].reduce((content, [key, val]) => {
    content[key] = val;
    return content;
  }, {});
}

Object.fromEntries = Object.fromEntries || fromEntries;

// eg To convert "focus_percent_x" to "focusPercentX"
export const renameKeys = content => Object.fromEntries(
  Object.entries(content)
    .map(([key, val]) => [
      key.replace(/_(.)/g, g => g[1].toUpperCase()),
      processVal(val)
    ])
);

const processVal = val => {
  if (val === null) {
    return val;
  }

  return typeof val !== 'object'
    ? val
    : Array.isArray(val)
      ? areAllChildrenStrings(val)  // stop rename splitting each character into an object
        ? val : val.map(renameKeys)
      : renameKeys(val);
};

const areAllChildrenStrings = arr => arr.some(x => (typeof x === 'string'));

/* eslint-enable */
